import React, { useState } from 'react';
import { KTSVG } from '../../../../_metronic/helpers';
import { putServiceOne } from '../../../services/servicesService';
import { formatarDataOS } from '../../../utils/date';
import { useToast } from '../../../pages/components/Toats';
import { useAuth } from '../../../modules/auth';
import { LoadingSpan } from '../../../pages/components/Loadings/loadingSpan';
import useSize from '../../../hooks/useSize';
import itemStyles from './itemOrderOfService.module.css';
import { useOrderServicePdf } from '../useOrderServicePdf';
import { OrderServiceStatusDropdown } from '../OrderServiceStatusDropdown';
import { NuklieConversationButton } from '../../../pages/components/Nuklie';


type Props = {
    itemOrderOfService: any;
    refresh: any;
    setShowModalDelete: any
    setMyOrderService: any
    setShowCreateAppModal: any
    setShowModalTemplate: any
    onOpenDetails?: (order: any) => void
    layoutMode?: 'default' | 'checklist'
}

export function ItemOrderOfService({
    itemOrderOfService, 
    refresh, 
    setShowModalDelete, 
    setMyOrderService, 
    setShowCreateAppModal,
    setShowModalTemplate,
    onOpenDetails,
    layoutMode = 'default',
} : Props) {

    const [loadingUpdateOS, setLoadingUpdateOS] = useState<boolean>(false);
    const { toggleToast } = useToast();
    const { previewPDF: generateOrderPdf, loadingPDF } = useOrderServicePdf()
    const {currentUser} = useAuth()
    const [idOS, setIdOS] = useState<any>(null)
    const {width : largura} = useSize()
    
    const updateOSOne = async (id: any, status: any) => {
        try {
          setLoadingUpdateOS(true)
          const body = {
            status: status
          }
          await putServiceOne(id, body)
          toggleToast("Sucesso ao atualizar a O.S. ", "success")
          //setClients(MyClient)
    
        } catch (error) {
          console.log(error)
          toggleToast("Erro ao atualizar a O.S. ", "error")
          
        }finally{
          setLoadingUpdateOS(false)
          refresh()
        }
    }


  const statusDropdownId = `os-status-dd-${itemOrderOfService?.id}`
  const isChecklist = layoutMode === 'checklist'
  const fsTitle = isChecklist ? '6' : largura < 1200 ? '6' : '4'
  const fsBody = isChecklist ? '7' : largura < 1200 ? '7' : '6'
  const fsBadge = isChecklist ? '8' : largura < 1200 ? '9' : '7'
  const iconSize = isChecklist ? '2x' : largura < 1200 ? '2x' : '2hx'

  const canChangeStatus = Boolean(
    currentUser && currentUser.role && currentUser.role.slug !== 'CLIENTE'
  )
  const clientName =
    itemOrderOfService?.client?.nameResponsible ?? 'Não identificado.'
  const collaboratorName =
    itemOrderOfService?.collaborators?.length > 0
      ? itemOrderOfService.collaborators[0].name
      : 'Não identificado'
  const dateInitText = itemOrderOfService?.dateInit
    ? formatarDataOS(itemOrderOfService.dateInit)
    : 'Sem data para iniciar o serviço.'
  const dateEndText = itemOrderOfService?.dateEnd
    ? formatarDataOS(itemOrderOfService.dateEnd)
    : 'Sem data para finalizar o serviço.'

  const statusColor =
    itemOrderOfService?.status === 'AGUARDANDO'
      ? 'primary'
      : itemOrderOfService?.status === 'CANCELADO'
        ? 'danger'
        : itemOrderOfService?.status === 'FINALIZADO'
          ? 'success'
          : itemOrderOfService?.status === 'AGENDADO'
            ? 'info'
            : itemOrderOfService?.status === 'EM ANDAMENTO'
              ? 'warning'
              : 'secondary'

  const btnSizeStyle = isChecklist ? undefined : { height: '2.5rem', width: '2.5rem' }

  const renderActionButtons = () => (
    <>
      {onOpenDetails && (
        <button
          data-bs-toggle='tooltip'
          data-bs-placement='top'
          data-bs-trigger='hover'
          title='Ver detalhes da O.S.'
          onClick={(event: any) => {
            event.stopPropagation()
            setMyOrderService(itemOrderOfService)
            onOpenDetails(itemOrderOfService)
          }}
          className='btn btn-icon btn-bg-light btn-active-primary me-1'
          style={btnSizeStyle}
        >
          <i className='bi bi-eye-fill fs-2'></i>
        </button>
      )}

      <NuklieConversationButton
        resource='client'
        id={itemOrderOfService?.client?.id}
        className='me-1'
        style={btnSizeStyle}
      />

      <button
        data-bs-toggle='tooltip'
        data-bs-placement='top'
        data-bs-trigger='hover'
        title='Imprimir O.S'
        onClick={(event: any) => {
          event.stopPropagation()
          setIdOS(itemOrderOfService.id)
          generateOrderPdf(itemOrderOfService)
        }}
        className='btn btn-icon btn-bg-light btn-active-primary me-1'
        style={btnSizeStyle}
      >
        {loadingPDF && itemOrderOfService && idOS && idOS === itemOrderOfService.id ? (
          <LoadingSpan />
        ) : (
          <i className='bi bi-filetype-pdf fs-2'></i>
        )}
      </button>

      <button
        data-bs-toggle='tooltip'
        data-bs-placement='top'
        data-bs-trigger='hover'
        title='Editar O.S'
        onClick={(event: any) => {
          event.stopPropagation()
          setShowCreateAppModal(true)
          itemOrderOfService.idUnitBranch =
            itemOrderOfService && itemOrderOfService.unitBranch
              ? itemOrderOfService.unitBranch.id
              : null
          itemOrderOfService.idClient =
            itemOrderOfService && itemOrderOfService.client
              ? itemOrderOfService.client.id
              : null
          itemOrderOfService.idPlant =
            itemOrderOfService && itemOrderOfService.plant
              ? itemOrderOfService.plant.id
              : null
          itemOrderOfService.idCollaborator =
            itemOrderOfService &&
            itemOrderOfService.collaborators &&
            itemOrderOfService.collaborators.length > 0
              ? itemOrderOfService.collaborators[0].id
              : null
          setMyOrderService(itemOrderOfService)
        }}
        className='btn btn-icon btn-bg-light btn-active-primary me-1'
        style={btnSizeStyle}
      >
        <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-2' />
      </button>

      <button
        data-bs-toggle='tooltip'
        data-bs-placement='top'
        data-bs-trigger='hover'
        title='Editar Template'
        onClick={(event: any) => {
          event.stopPropagation()
          setShowModalTemplate(true)
          itemOrderOfService.idUnitBranch =
            itemOrderOfService && itemOrderOfService.unitBranch
              ? itemOrderOfService.unitBranch.id
              : null
          itemOrderOfService.idClient =
            itemOrderOfService && itemOrderOfService.client
              ? itemOrderOfService.client.id
              : null
          itemOrderOfService.idPlant =
            itemOrderOfService && itemOrderOfService.plant
              ? itemOrderOfService.plant.id
              : null
          itemOrderOfService.idCollaborator =
            itemOrderOfService &&
            itemOrderOfService.collaborators &&
            itemOrderOfService.collaborators.length > 0
              ? itemOrderOfService.collaborators[0].id
              : null
          setMyOrderService(itemOrderOfService)
        }}
        className='btn btn-icon btn-bg-light btn-active-primary me-1'
        style={btnSizeStyle}
      >
        <KTSVG path='/media/icons/duotune/art/art007.svg' className='svg-icon-2' />
      </button>

      <button
        onClick={(event: any) => {
          event.stopPropagation()
          setShowModalDelete(true)
          setMyOrderService(itemOrderOfService)
        }}
        data-bs-toggle='tooltip'
        data-bs-placement='top'
        data-bs-trigger='hover'
        title='Excluir O.S'
        className='btn btn-icon btn-bg-light btn-active-primary me-1'
        style={btnSizeStyle}
      >
        <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-2' />
      </button>

      {canChangeStatus && itemOrderOfService?.status !== 'CANCELADO' && (
        <button
          data-bs-toggle='tooltip'
          data-bs-placement='top'
          data-bs-trigger='hover'
          title='Cancelar O.S.'
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation()
            updateOSOne(itemOrderOfService.id, 'CANCELADO')
          }}
          className='btn btn-icon btn-bg-light btn-active-danger me-1'
          style={btnSizeStyle}
        >
          <i className='bi bi-x-circle fs-4' />
        </button>
      )}
    </>
  )

  const renderStatusDropdown = () => (
    <OrderServiceStatusDropdown
      id={statusDropdownId}
      status={itemOrderOfService?.status}
      canChange={canChangeStatus}
      loading={loadingUpdateOS}
      fsBadge={fsBadge}
      onChange={(status) => updateOSOne(itemOrderOfService.id, status)}
    />
  )

  return (
    <div
        style={{
          borderLeft: '4px solid',
          marginBottom: isChecklist ? 0 : '1rem',
        }}
        className={`${
            isChecklist ? itemStyles.inChecklist : ''
        } border-${
            itemOrderOfService && itemOrderOfService.status && itemOrderOfService.status !== null
            ? itemOrderOfService.status === "AGUARDANDO"
            ? "primary"
            : itemOrderOfService.status === "CANCELADO"
            ? "danger"
            : itemOrderOfService.status === "FINALIZADO"
            ? "success"
            : itemOrderOfService.status === "AGENDADO"
            ? "info"
            : itemOrderOfService.status === "EM ANDAMENTO"
            ? "warning"
            : "secondary"
            : "secondary"
        }`}
    >
        <div className={`card card-flush bg-light p-3 ${isChecklist ? itemStyles.checklistCard : ''}`}>
            <div
              className={`card-title ${isChecklist ? itemStyles.checklistCardTitle : ''}`}
              style={isChecklist ? undefined : {display: 'flex', justifyContent: 'space-between'}}
            >
                <h3 className='align-items-start flex-column' style={{display: "flex", minWidth: 0, width: '100%'}}>
                    <span className={`card-label fw-bold fs-${fsTitle} ${isChecklist ? itemStyles.checklistTitle : ''}`} title={itemOrderOfService?.title}>
                        {itemOrderOfService && itemOrderOfService.number_order_service 
                        ? itemOrderOfService.number_order_service : 0} 
                        {" "}-{" "} 
                        {itemOrderOfService && itemOrderOfService.title ? itemOrderOfService.title : "Sem Descrição"}
                    </span>

                </h3>

                {!isChecklist && (
                  <div>{renderActionButtons()}</div>
                )}
            </div>

            {isChecklist ? (
              <div className={`card-body p-0 ${itemStyles.checklistCardBody}`}>
                <div className={itemStyles.checklistInfoList}>
                  <div className={itemStyles.checklistInfoRow}>
                    <span className={itemStyles.checklistIconSlot} aria-hidden>
                      <i className="bi bi-person" />
                    </span>
                    <p
                      className={`${itemStyles.checklistInfoText} ${itemStyles.checklistClientName}`}
                    >
                      {clientName}
                    </p>
                  </div>
                  <div className={itemStyles.checklistInfoRow}>
                    <span className={itemStyles.checklistIconSlot} aria-hidden>
                      <i className="bi bi-calendar-event" />
                    </span>
                    <div className={itemStyles.checklistInfoText}>
                      <p className={itemStyles.checklistDateLine}>
                        <span className={itemStyles.checklistLabel}>Início:</span>
                        {dateInitText}
                      </p>
                    </div>
                  </div>
                  <div className={itemStyles.checklistInfoRow}>
                    <span className={itemStyles.checklistIconSlot} aria-hidden>
                      <i className="bi bi-calendar-check" />
                    </span>
                    <div className={itemStyles.checklistInfoText}>
                      <p className={itemStyles.checklistDateLine}>
                        <span className={itemStyles.checklistLabel}>Fim:</span>
                        {dateEndText}
                      </p>
                    </div>
                  </div>
                  <div className={itemStyles.checklistInfoRow}>
                    <span className={itemStyles.checklistIconSlot} aria-hidden>
                      <i className="bi bi-hammer" />
                    </span>
                    <p className={itemStyles.checklistInfoText}>{collaboratorName}</p>
                  </div>
                  <div
                    className={`${itemStyles.checklistInfoRow} ${itemStyles.checklistStatusRow}`}
                  >
                    <span className={itemStyles.checklistIconSlot} aria-hidden>
                      <i className="bi bi-flag" />
                    </span>
                    <div className={itemStyles.checklistInfoContent}>
                      {renderStatusDropdown()}
                    </div>
                  </div>
                  <div
                    className={`${itemStyles.checklistInfoRow} ${itemStyles.checklistActionsRow}`}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                    role="presentation"
                  >
                    <span className={itemStyles.checklistIconSlot} aria-hidden />
                    <div className={itemStyles.checklistActions}>
                      {renderActionButtons()}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
            <div className='card-body p-0' style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <div style={{display: 'flex', flexDirection: 'column', gap: '0.5rem'}}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                        <KTSVG path="/media/icons/duotune/communication/com006.svg" className={`svg-icon-muted svg-icon-${iconSize}`}/>
                        <h3>
                            <span className={`text-muted fw-semibold fs-${fsBody}`}>
                                {clientName}
                            </span>
                        </h3>
                    </div>

                    <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                        <KTSVG path="/media/icons/duotune/files/fil002.svg" className={`svg-icon-muted svg-icon-${iconSize}`}/>
                        <div>
                            <h3 style={{marginBottom: '0rem', paddingBottom: '0rem'}}>
                                <span className={`text-gray-800 fw-bold fs-${fsBody}`}>
                                    Início:{" "}
                                </span>
                                <span className={`text-muted fw-semibold fs-${fsBody}`}>
                                    {dateInitText}
                                </span>
                            </h3>
                            <h3 style={{marginBottom: '0rem', paddingBottom: '0rem'}}>
                                <span className={`text-gray-800 fw-bold fs-${fsBody}`}>
                                    Fim:{" "}
                                </span>
                                <span className={`text-muted fw-semibold fs-${fsBody}`}>
                                    {dateEndText}
                                </span>
                            </h3>
                        </div>
                    </div>

                    <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                        <i className="bi bi-hammer" aria-hidden />
                        {/* <KTSVG path="/media/icons/duotune/files/fil002.svg" className={`svg-icon-muted svg-icon-${largura < 1200 ? "2x" : "2hx"}`}/> */}
                        <div>
                            <h3 style={{marginBottom: '0rem', paddingBottom: '0rem'}}>
                                <span className={`text-muted fw-semibold fs-${fsBody}`}>
                                    {collaboratorName}
                                </span>
                            </h3>
                        </div>
                    </div>

                    <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                        <KTSVG path="/media/icons/duotune/maps/map001.svg" className={`svg-icon-muted svg-icon-${iconSize}`}/>
                        <div>
                            {renderStatusDropdown()}
                        </div>
                    </div>
                </div>
            </div>
            )}
        </div>
    </div>
  );
}
